import Return from "./Return";

export default Return;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Return/index.js